import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import Spoiler from '../../../../../../../components/Spoiler'
import getInventoryAvailabilityTimelineData from './helpers/getInventoryAvailabilityTimelineData'
import TimeLinesContainerWithBoundaries from './TimeLinesContainerWithBoundaries'

import { getPercentageAllocationInventoryToTarget } from '../../formatters/percentageAllocationHelpers/getPercentageAllocationInventoryToTarget'
import { getGamInventoryType, getInventoryIds, getInventoryItemId, inventoryTypes } from '../../helpers'
import { getDatesWithInventoryOverlap } from '../../validation/noOverlappingGamTargetingPerInventoryPerDay'

import { lineItemsSelector } from '../../../../../../../modules/selectors/lineItems'
import { rightSelector } from '../../../../../../../modules/selectors/rights'
import { ENVIRONMENT_TYPE } from '../../fields'
import { AD_INVENTORY } from '../../../../../../Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/fields'

import useStyles from './styles'

const InventoryAvailabilitySpoiler = ({ formikValues }) => {
  const classes = useStyles()
  const { t } = useTranslation()

  const existingLineItems = useSelector(lineItemsSelector)
  const right = useSelector(rightSelector)
  const inventoryType = getGamInventoryType(right[AD_INVENTORY])

  const title = useMemo(() => {
    return inventoryType === inventoryTypes.placements ? 'Availability of placements:' : 'Availability of ad units:'
  }, [inventoryType])

  const environmentType = formikValues[ENVIRONMENT_TYPE]

  const selectedInventory = getPercentageAllocationInventoryToTarget(formikValues, right)

  const { timelineStartDate, timelineEndDate } = useMemo(() => getInventoryAvailabilityTimelineData(right), [right])

  const timelinesList = useMemo(() => {
    return selectedInventory.map(inventoryItem => {
      // Get conflict dates for THIS specific inventory item only
      const conflictDates = getDatesWithInventoryOverlap({
        existingLineItems,
        proposedInventoryIds: [getInventoryItemId(inventoryItem)], // Only this inventory item
        environmentType
      })

      return {
        id: getInventoryItemId(inventoryItem),
        conflictDates,
        name: inventoryItem.name,
        label: inventoryItem.name
      }
    })
  }, [selectedInventory, existingLineItems, environmentType])

  // const hasConflicts = conflictDates.length > 0
  const hasConflicts = useMemo(() => {
    // Get selected inventory details
    const proposedInventoryIds = getInventoryIds(selectedInventory)

    // Check if there are any conflicts across all selected placements
    const conflictDates = getDatesWithInventoryOverlap({
      existingLineItems,
      proposedInventoryIds,
      environmentType
    })
    return conflictDates.length > 0
  }, [environmentType, existingLineItems, selectedInventory])

  if (!selectedInventory || selectedInventory.length === 0) {
    return null
  }

  return (
    <Spoiler title={t(title)} triggerOpen={hasConflicts} spoilerTitleClassName={classes.spoilerTitleClassName}>
      <TimeLinesContainerWithBoundaries
        timelinesList={timelinesList}
        startDate={timelineStartDate}
        endDate={timelineEndDate}
      />
    </Spoiler>
  )
}

export default InventoryAvailabilitySpoiler
